export default "__VITE_ASSET__8H6TfUoj__"